import styles from "./AssessmentMental.module.scss";
import { classNames } from "@/shared/lib/classNames/classNames";

export const AssessmentMental = () => {
    return (
        <div className={styles.assessmentMental}>
            <div className={styles.title}>What is mental tension?</div>
            <div className={styles.content}>
                <div className={styles.text}>
                    <strong>The main sign of mental tension</strong> is the
                    feeling of being unable to live normally; sleep does not
                    provide rest. With mental tension, both mental and physical
                    fatigue constantly accumulates and leads to the destruction
                    of life and health.
                </div>
                <div
                    className={classNames(styles.text, {}, [styles.secondText])}
                >
                    <strong>Mental fatigue</strong> is a bad mood, tension in
                    the head, inability to talk to someone, no energy to work,
                    nerves on edge, no concentration, you can’t make yourself do
                    anything.
                </div>
            </div>
        </div>
    );
};
